export default "__VITE_ASSET__CFx76n_c__"